export interface CustomerOrderSettings {
  enabled: boolean;
  flow: "direct" | "quote" | "both";
  missing_price: "base" | "block";
  allow_price_override: boolean;
  allow_price_list_change: boolean;
  default_template_id: string | null;
  recipients: string[];
  sender_identity_id: string;
  subject: string;
  message: string;
  send_mode: "manual" | "on_confirm";
}
export const DEFAULT_CUSTOMER_ORDERS: CustomerOrderSettings = {
  enabled: false,
  flow: "both",
  missing_price: "base",
  allow_price_override: true,
  allow_price_list_change: true,
  default_template_id: null,
  recipients: [],
  sender_identity_id: "",
  subject: "Ordine {order_number}",
  message: "In allegato l’ordine da preparare.",
  send_mode: "manual",
};
export function customerOrderSettings(settings: any): CustomerOrderSettings {
  return {
    ...DEFAULT_CUSTOMER_ORDERS,
    ...settings?.warehouse_settings?.customer_orders,
  };
}
